export default "__VITE_ASSET__CTDHd6uh__"